<template>
  <div>
    <div>
      <b-modal :visible="visible" centered hide-header hide-footer no-close-on-backdrop>
        <div class="d-block text-center modal-container">
          <div class="content-header">{{ $t('selfcheck.checkOutContentHasBeenChanged') }}</div>
          <div class="content-desc">{{ $t('selfcheck.pleaseCheckAgain') }}</div>
          <div class="content-button">
            <so-close-button @click="$emit('close')">
              {{ $t('common.close') }}
            </so-close-button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import SoCloseButton from '@/components/common/SoCloseButton'

export default {
  name: 'AmountChangedModal',
  components: {
    SoCloseButton,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.modal-container {
  padding-top: 8px;
}
.content {
  color: #222222;

  &-header {
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 16px;
  }

  &-desc {
    padding: 16px 0 0;
    margin-bottom: 36px;
  }

  &-button {
    display: flex;
    justify-content: center;
  }
}
.col {
  padding-left: 4px;
  padding-right: 4px;
}
</style>
